<template>
  <div class="select-competition-modal modal">
    <div class="modal-inner">
      <div class="modal-content to-perfect-company">
        <div class="title">
          <p class="close" @click="close"></p>
        </div>
        <div class="content">
          <div class="img">
            <img src="https://cdn.fabricschina.com.cn/statics/pattern-design/icon/bi.png" alt="完善企业信息">
          </div>
          <p class="h3">{{this.language==="cn"?'完善企业信息':'Please supplement the company information'}}</p>
          <p class="tip" v-if="this.language==='cn'">（申报面料需要您先完善企业信息后，方可申报）</p>
        </div>
        <div class="btns">
          <Button class="btn" style="width: 226px;" @click="toPerfectCompany">{{this.language==="cn"?'立即前往':'Go'}}</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      language: ""
    }
  },
  watch: {
    "$store.state.language": function(){
      this.language = this.$store.state.language;
    }
  },
  created () {
    this.language = this.$store.state.language
  },
  methods: {
    toPerfectCompany(){
      this.close()
      let path = "/competition/company"
      if(this.language === "en"){
        path = "/en"+path
      }
      this.$router.push({
        path: path
      })
    },
    close(){
      this.$store.commit("setPerfectCompanyInfoModal", false);
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-inner{
    display: table-cell;
    vertical-align: middle;
  }
  .modal-content{
    width: 750px;
    height: 314px;
    margin: 0 auto;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;
    .title{
      height: 56px;
      line-height: 56px;
      position: relative;
      padding: 0 20px;
      .close{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 10px;
        height: 10px;
        right: 20px;
        margin: auto;
        color: #919EAB;
        cursor: pointer;
        background: url(https://cdn.fabricschina.com.cn/statics/pattern-design/icon/close.png) no-repeat 0 0/100% 100%;
      }
    }
  }
  .to-perfect-company{
    width: 504px;
    height: 360px;
    .content{
      border: none;
      height: auto;
      padding: 10px 0;
      .img{
        width: 90px;
        height: 90px;
        margin: 0 auto 30px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .tip{
        line-height: 38px;
        color: #4B5D6C;
      }
    }
    .btns{
      margin-top: 14px;
    }
  }
</style>